import React from 'react';
export function TradingEdgeCard() {
  return <div className="glass-border rounded-[20px] p-6" data-id="element-269">
      <h3 className="text-sm font-heading text-text-primary mb-6" data-id="element-270">
        Trading Edge
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-6" data-id="element-271">
        {/* Left: Profit Factor hero */}
        <div className="flex flex-col items-center justify-center p-4 bg-background-elevated/30 rounded-xl" data-id="element-272">
          <div className="text-3xl font-numbers font-light text-text-primary mb-1" data-id="element-273">
            2.14
          </div>
          <div className="bg-success/10 text-success rounded-full px-3 py-0.5 text-[10px] font-medium uppercase tracking-wider mb-2" data-id="element-274">
            Strong
          </div>
          <div className="text-[10px] font-label text-text-tertiary uppercase" data-id="element-275">
            Profit Factor
          </div>
        </div>

        {/* Right: Details grid */}
        <div data-id="element-276">
          {/* Win/Loss bar */}
          <div className="mb-4" data-id="element-277">
            <div className="flex items-center justify-between text-xs font-numbers mb-1.5" data-id="element-278">
              <span className="text-success" data-id="element-279">Avg Win: $184</span>
              <span className="text-danger" data-id="element-280">Avg Loss: $86</span>
            </div>
            <div className="w-full h-2 bg-background-elevated rounded-full overflow-hidden flex" data-id="element-281">
              <div className="h-full bg-success" style={{
              width: '68%'
            }} data-id="element-282" />
              <div className="h-full bg-danger" style={{
              width: '32%'
            }} data-id="element-283" />
            </div>
          </div>

          {/* Stats grid */}
          <div className="grid grid-cols-4 gap-3" data-id="element-284">
            <div className="bg-background-elevated/50 rounded-xl p-3" data-id="element-285">
              <div className="text-[10px] font-label text-text-tertiary uppercase mb-1" data-id="element-286">
                Best Trade
              </div>
              <div className="text-sm font-numbers text-success" data-id="element-287">+$412.50</div>
            </div>
            <div className="bg-background-elevated/50 rounded-xl p-3" data-id="element-288">
              <div className="text-[10px] font-label text-text-tertiary uppercase mb-1" data-id="element-289">
                Worst Trade
              </div>
              <div className="text-sm font-numbers text-danger" data-id="element-290">-$198.20</div>
            </div>
            <div className="bg-background-elevated/50 rounded-xl p-3" data-id="element-291">
              <div className="text-[10px] font-label text-text-tertiary uppercase mb-1" data-id="element-292">
                Avg Hold Time
              </div>
              <div className="text-sm font-numbers text-text-primary" data-id="element-293">4.2h</div>
            </div>
            <div className="bg-background-elevated/50 rounded-xl p-3" data-id="element-294">
              <div className="text-[10px] font-label text-text-tertiary uppercase mb-1" data-id="element-295">
                Total Trades
              </div>
              <div className="text-sm font-numbers text-text-primary" data-id="element-296">146</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}